import { CUSTOM_QUEUE } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  businessHoursList: [] as any,
  businessHoursSearchList: [] as any,
  contactNumberList: [] as any,
  queueList: [] as any,
  promptLibraryData: [] as any,
  editData: {} as any,
  customQueueData: {} as any,
  enableQueueList: [] as any,
  initialMenu: [] as any,
  percentage: "",
  completedMenu: {} as any,
  selectedMenu: "",
  create: false,
  isOpenAudioPlayer: false,
  audioPlayerData: {} as any,
  playerName: "",
  doPause: false,
  doPlay: false,
  userList: [],
  userUpdate: false,
  businessHoursConstant: [] as any,
  isUpdate: false,
  isUpdated: false,
  routingListTableData: [] as any,
  routingListConstantData: [] as any,
  agentstatusList: [] as any,
  agentstatusdata: [] as any,
  skillmanagementList: [] as any,
  customTagList: [] as any,
  customTagListConst: [] as any,
  isUpdateCustome: false,
  didList: [] as any,
  enableSkillmanagementList: [] as any,
  routingProfileEnableList: [] as any,
  contactList1: [] as any,
  contactConstant: [] as any,
  webChatList: [] as any,
  defaultAudioPlayId: "",
  promptType: "" as any,
  promptValue: "" as any,
  quickActnData: [] as any,
  quickActnEditData: {} as any,
  isQuickActnEdit: false,
  templateBot: {} as any,
  maxWaitTime: 0 as any,
  // editQuickActnData : {} as any,
  isMenuoptionEdit:false as Boolean,
  isCarouselEdit:false as Boolean,
  isIntentSave:false as Boolean,
  previewNodes:[] as any,
  isCreateCustomerModalOpen: false as Boolean,
};

const customQueueSlice: any = createSlice({
  name: CUSTOM_QUEUE,
  initialState,

  reducers: {
    initialMenu: (state, { payload }) => {
      state.initialMenu = payload.initialMenu;
      state.percentage = payload.percentage;
      state.completedMenu = payload.completedMenu;
      state.selectedMenu = payload.selectedMenu;
    },

    customerTagData: (state, { payload }) => {
      state.customTagList = payload.customTagList;
      state.isUpdateCustome = payload.isUpdateCustome;
      state.customTagListConst = payload.customTagListConst;
    },

    setupEdit: (state, { payload }) => {
      state.editData = {
        isEdit: payload?.isEdit ?? false,
        editDataName: payload.editDataName ?? "",
        editData: payload?.editData,
        channel:payload?.channel,
        templateCopy:payload?.templateCopy,
      };
    },

    setupCreate: (state, { payload }) => {
      state.create = payload.create;
    },

    doOpenAudioPlayer: (state, { payload }) => {
      state.isOpenAudioPlayer = payload.isOpenAudioPlayer;
      state.audioPlayerData = payload.audioPlayerData;
      state.playerName = payload.playerName;
      state.doPause = payload.doPause;
      state.doPlay = payload.doPlay;
    },

    businessHours: (state, { payload }) => {
      state.businessHoursList = payload?.businessHoursList;
      state.businessHoursSearchList = payload?.businessHoursSearchList;
    },

    routingProfileData: (state, { payload }) => {
      state.routingListTableData = payload.routingListTableData;
      state.routingListConstantData = payload.routingListConstantData;
    },

    contactCenterNumber: (state, { payload }) => {
      state.contactNumberList = payload?.contactNumberList;
      state.isUpdated = payload.isUpdated;
      state.didList = payload.didList;
    },

    contacts: (state, { payload }) => {
      state.contactList1 = payload.contactList1;
      state.contactConstant = payload.contactConstant;
    },

    userManagement: (state, { payload }) => {
      state.userList = payload.userList;
      state.userUpdate = payload.userUpdate;
    },

    agentStatus: (state, { payload }) => {
      state.agentstatusList = payload.agentstatusList;
      state.agentstatusdata = payload.agentstatusdata;
    },

    skillManagement: (state, { payload }) => {
      state.skillmanagementList = payload?.skillmanagementList;
    },

    skillManagementEnable: (state, { payload }) => {
      state.enableSkillmanagementList = payload?.enableSkillmanagementList;
    },

    queueList: (state, { payload }) => {
      state.queueList = payload?.queueList;
    },

    queueListEnable: (state, { payload }) => {
      state.enableQueueList = payload?.enableQueueList;
    },

    replaceItemInQueueList: (state, { payload }) => {
      state.queueList.splice(payload.index, 1, payload.data);
    },

    routingProfileEnable: (state, { payload }) => {
      state.routingProfileEnableList = payload.routingProfileEnableList;
    },

    promptLibraryData: (state, { payload }) => {
      state.promptLibraryData = payload?.promptLibraryData;
    },
    addDefaultAudioId: (state, { payload }) => {
      state.defaultAudioPlayId = payload.id;
    },
    webChatList: (state, { payload }) => {
      state.webChatList = payload;
    },
    quickActionList: (state, { payload }) => {
      state.quickActnData = payload;
    },
    quickActionEdit: (state, { payload }) => {
      state.quickActnEditData = {
        isQuickActnEdit: payload?.isQuickActnEdit ?? false,
        quickActnEditData: payload?.quickActnEditData,
      };
    },
    templateBot: (state, { payload }) => {
      state.templateBot = {
        isTemplateBot: payload?.isTemplateBot ?? false,
        templateName: payload.templateName ?? "",
        channel: payload.channel ?? "",
        descriptionName: payload.descriptionName ?? "",
        isLanguage : payload.isLanguage ?? "",
        flowView:payload?.flowView
      };
    },
    maxWaitTime: (state, { payload }) => {
      state.maxWaitTime = payload
    },
    setIsMenuOptionEdit:(state,{payload})=>{
      state.isMenuoptionEdit = payload
    },
    saveIntent:(state,{payload})=>{
      state.isIntentSave = payload
    },
    setIsCarouselEdit:(state,{payload})=>{
      state.isCarouselEdit = payload
    },
    setPreviewNodes: (state, { payload }) => {
      state.previewNodes = payload
    },
    setIsCreateCustomerModalOpen: (state, { payload }) => {
      state.isCreateCustomerModalOpen = payload
    },
    reset: () => { },
  },
});

export const CustomQueueActions = customQueueSlice.actions;
export default customQueueSlice.reducer;
